import ViewTitle from './ViewTitle';

export { ViewTitle };
export default { ViewTitle };
